import {ApiDataModel} from "../../model/api-data-model";
import {SOURCE_USER} from "../../model/traceable";

// Shared FX-autofill primitives (US-1171), used by both the asset FOV and the
// deal-funds components so the empty-check and provenance rules cannot drift.

/** Provenance value written to a TraceablePercent.source for a user-entered rate.
 *  Re-exported from the shared traceable model so existing fx imports keep working. */
export {SOURCE_USER};

/** Provenance value for an untouched autofilled rate: "ECB {as-of date}". */
export const fxAutofillEcbSource = (asOfDate: string): string => `ECB ${asOfDate}`;

/** Store slice holding the latest autofill result for a single currency pair. */
export type FxAutofillSlice = ApiDataModel<{ fraction: number | null; asOfDate: string | null }>;

/**
 * A rate field is "empty" — i.e. autofill-eligible — only when no value is
 * persisted. Judge this from the persisted fraction, never from a form control's
 * placeholder default (e.g. deal-funds defaults the control to 1), otherwise a
 * legitimately saved rate of exactly 1.0 between pegged currencies looks empty.
 */
export const isFxRateEmpty = (persistedFraction: number | null | undefined): boolean =>
    persistedFraction == null;

/**
 * Provenance source to persist for an FX rate:
 * - untouched autofilled rate → "ECB {asOfDate}"
 * - rate the user typed/edited → "user"
 * - otherwise                  → keep the existing source unchanged
 */
export const fxAutofillSource = (
    untouched: boolean,
    asOfDate: string | null,
    changed: boolean,
    existingSource: string | undefined
): string | undefined =>
    untouched && asOfDate
        ? fxAutofillEcbSource(asOfDate)
        : (changed ? SOURCE_USER : existingSource);
